const COLUMN_GAP = 30;

export default () => ({
  carouselWidth: 0,
  cardWidth: 0,
  gradientLeftWidth: 0,
  gradientRightWidth: 0,
  cardOffset: 0,
  carouselWrapper: null,
  scrollRight: true,
  scrollLeft: false,

  next() {
    const cards = this.carouselWrapper.querySelectorAll('.tarif-option');
    const distance = cards[cards.length - 1].offsetLeft - this.carouselWidth;
    if (distance > 30) {
      this.cardOffset -= this.cardWidth + COLUMN_GAP;
    } else if (this.scrollRight) {
      this.cardOffset -= this.cardWidth + distance;
      this.scrollRight = false;
      if (((distance - 30) / (COLUMN_GAP + this.cardWidth)) % 1 !== 0) {
        const l = this.gradientLeftWidth;
        this.gradientLeftWidth = this.gradientRightWidth;
        this.gradientRightWidth = l;
      }
    }
    this.scrollLeft = true;
  },

  prev() {
    if (-this.cardOffset <= this.cardWidth + COLUMN_GAP) {
      if ((this.cardOffset / (COLUMN_GAP + this.cardWidth)) % 1 !== 0) {
        const l = this.gradientLeftWidth;
        this.gradientLeftWidth = this.gradientRightWidth;
        this.gradientRightWidth = l;
      }
      this.cardOffset = 0;
      this.scrollLeft = false;
    } else {
      this.cardOffset += this.cardWidth + COLUMN_GAP;
    }
    this.scrollRight = true;
  },

  //moves tooltip when it would be cliped by container, so it remains visible
  positionTooltip() {
    const tooltip = this.$el.querySelector('.tarif-price__popup');
    if (!tooltip) {
      return;
    }

    //how much tooltip overflows over card on one side
    const tooltipOverflow =
      (this.$el.querySelector('.tarif-popup').getBoundingClientRect().width -
        this.cardWidth) /
      2;

    const offsetLeft = this.$el.offsetLeft;
    const cardRight = offsetLeft + this.cardWidth;
    const carouselWithTooltip = this.carouselWidth - tooltipOverflow;

    //if left side of the tooltip would be clipped
    tooltip.classList.toggle(
      'tarif-price__popup--right',
      offsetLeft < tooltipOverflow
    );

    //if right side of the tooltip would be clipped
    tooltip.classList.toggle(
      'tarif-price__popup--left',
      cardRight > carouselWithTooltip
    );

    //set css variables to move the tooltip
    tooltip.style.setProperty('--left', -offsetLeft + 'px');
    tooltip.style.setProperty('--right', cardRight - this.carouselWidth + 'px');
  },

  init() {
    this.carouselWrapper = this.$el;
    this.carouselWidth = this.$el.getBoundingClientRect().width;
    this.cardWidth = this.$el
      .querySelector('.tarif-option')
      .getBoundingClientRect().width;
    this.gradientRightWidth =
      (((this.carouselWidth + COLUMN_GAP) / (this.cardWidth + COLUMN_GAP)) %
        1) *
      this.cardWidth;
    this.gradientLeftWidth = this.cardWidth;
    const cards = this.carouselWrapper.querySelectorAll('.tarif-option');
    if (
      cards[cards.length - 1].offsetLeft + Math.floor(this.cardWidth) <=
      this.carouselWidth
    ) {
      this.scrollRight = false;
    }
  },
});
